const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('ziiven-ziven-core', 'common/helpers/uploadFile');